const SvgPromoCorrect = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1819_13813)">
        <path
          d="M16.3015 3.36986C16.1555 3.37412 16.0168 3.43506 15.9148 3.53978L6.18753 13.2671L2.08523 9.16478C2.0334 9.1108 1.97132 9.0677 1.90262 9.03801C1.83392 9.00832 1.75999 8.99263 1.68516 8.99187C1.61032 8.99111 1.53609 9.00529 1.4668 9.03358C1.39752 9.06187 1.33457 9.10369 1.28165 9.15661C1.22873 9.20953 1.1869 9.27248 1.15862 9.34176C1.13033 9.41105 1.11615 9.48528 1.11691 9.56012C1.11767 9.63495 1.13336 9.70889 1.16305 9.77758C1.19274 9.84628 1.23584 9.90836 1.28982 9.96019L5.78982 14.4602C5.89532 14.5656 6.03837 14.6249 6.18753 14.6249C6.33669 14.6249 6.47974 14.5656 6.58523 14.4602L16.7102 4.33519C16.7914 4.25616 16.8468 4.15447 16.8692 4.04343C16.8916 3.93239 16.8799 3.81718 16.8358 3.71286C16.7916 3.60855 16.717 3.52 16.6217 3.4588C16.5263 3.3976 16.4148 3.3666 16.3015 3.36986Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <clipPath id="clip0_1819_13813">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPromoCorrect;
